import { render, staticRenderFns } from "./TowerDefense.vue?vue&type=template&id=4bfee13e&scoped=true"
import script from "./TowerDefense.vue?vue&type=script&lang=js"
export * from "./TowerDefense.vue?vue&type=script&lang=js"
import style0 from "./TowerDefense.vue?vue&type=style&index=0&id=4bfee13e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfee13e",
  null
  
)

export default component.exports